import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["option", "selected"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import { useDeviceType } from '../../../../responsive';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SingleSelectItem(props) {
  var option = props.option,
    selected = props.selected,
    divProps = _objectWithoutProperties(props, _excluded);
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, divProps), {}, {
    className: styles['item'],
    children: [!!option.leftAdornment && /*#__PURE__*/_jsx("div", {
      className: styles['icon'],
      children: option.leftAdornment
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['label'],
      children: [/*#__PURE__*/_jsx("div", {
        children: option.label
      }), option.description && /*#__PURE__*/_jsx("div", {
        className: styles['description'],
        children: option.description
      })]
    }), selected && /*#__PURE__*/_jsx("div", {
      className: styles['selected-indicator'],
      children: /*#__PURE__*/_jsx(IconFunctionalSuccess16, {})
    })]
  }));
}